<template>
  <div>
    <a-form>
      <a-result :title="title" :is-success="true" sub-title="" style="max-width: 560px; margin: 40px auto 0;">
        <template #icon></template>
        <div >
          <QRCode
            v-if="order&& order.qrCode"
            :codeString="order.qrCode"
            :codeName="setQRCodeTargetFullName"
            :showDownloadBtn="false"
          >
            <template v-slot:describeBottom>
              <h2 style="color: #fa8c16;line-height: 1.5">
                {{ setQRCodeTargetFullName }}
              </h2>
            </template>
          </QRCode>

        </div>
        <div class="information">
        </div>
      </a-result>
    </a-form>
  </div>
</template>

<script>
import QRCode from '@/components/QRCode'
import { ShowPayState } from '../../../../api/recharge'
export default {
  name: 'Step3',
  components: { QRCode },
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      title: '',
      setQRCodeTargetFullName: "支付二维码",
      loading: false,
      minutes: '', //倒计时分钟
      seconds: '', //倒计时秒
      isEnd: false, //支付超时
      timer: null,
    }
  },
  created() {
    this.$nextTick(async () => {
      this.show()
    })
  },
  beforeDestroy() {
    this.clearIntervalAndData()
  },
  methods: {
    show(){
      this.title = this.order.payType === 1 ? "请用微信扫码支付" : "请用支付宝扫码支付"
      //倒计时
      this.countDown()
    },
    // 倒计时
    countDown() {
      // 当前时间
      let nowTime = new Date()
      // 获取创建订单15分钟后的时间,this.payForm.create_time:订单创建时间
      let endTime = new Date(this.order.expiredAt);
      // 两个日期相差的时间戳，以毫秒为单位（1000ms = 1s）
      let totalTime = endTime - nowTime
      // 结束时间大于现在的时间
      if (totalTime > 0) {
        this.timer = setInterval(() => {
          if (totalTime >= 0) {
            //获取分钟数
            let minutes =Math.floor((((totalTime % (3600 * 24 * 1000)) / 1000) % 3600) / 60);
            //获取秒数
            let seconds =Math.floor((((totalTime % (3600 * 24 * 1000)) / 1000) % 3600) % 60).toString().padStart(2, "0");
            this.minutes = minutes
            this.seconds = seconds
            this.setQRCodeTargetFullName = `剩余时间：${minutes} 分 ${seconds} 秒`
            if ( Math.floor(totalTime/1000) %5 === 0){
              this.getPayState()
            }
            totalTime -= 1000;
            // console.log(totalTime)
          } else {
            //超时  清除定时任务 跳转到结果页面
            this.clearIntervalAndData()
          }
        }, 1000);
      } else {
        this.isEnd = true
      }
    },
    //查询订单状态
    getPayState(){
      ShowPayState(this.order.id).then( res => {
        //支付成功  跳转到下一页
        let state = res.data.collection[0]
        this.order.payState = state
        if (state === 2){
          this.clearIntervalAndData()
        }
      })
    },
    clearIntervalAndData(){
      this.minutes = 0
      this.seconds = 0
      clearInterval( this.timer); // 停止调用函数
      this.nextStep()
    },
    nextStep () {
      this.$emit('nextStep', this.order)
    }
  }
}
</script>
<style lang="less" scoped>
  .information {
    line-height: 22px;
    .ant-row:not(:last-child) {
      margin-bottom: 24px;
    }
  }
  .money {
    font-family: "Helvetica Neue",sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 14px;
  }
</style>
